import {Box, styled} from '@mui/system';


export const EventSection = styled('div')(({theme}) => ({
  'flexGrow': '1',
  'paddingTop': '10px',
  [theme.breakpoints.down('sm')]: {
    'padding': '0',
  },
}));

export const TimeSelectSection = styled(EventSection)(({theme}) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '360px',
  minWidth: 'fit-content',
}));


export const Slots = styled(Box)(({theme}) => ({
  display: 'flex',
  flexGrow: '1',
  flexDirection: 'column',
  overflowY: 'auto',
  marginTop: '28px',
  padding: '4px 7px',
  marginBottom: '1rem',
  button: {
    // fontWeight: '500',
    // minWidth: '140px',
    // marginBottom: '.5rem',
    // whiteSpace: 'nowrap',
  },
}));

export const SlotDivider = styled('hr')(({theme}) => ({
  marginTop: '15px',
  marginBottom: '24px',
  width: '20%',
  borderStyle: 'none',
  borderBottom: `1px solid ${theme.palette.common.swatch['50']}`,
}));

export const SlotsHeaderDayName = styled('div')(({theme}) => ({
  color: theme.palette.text.primary,
  lineHeight: '20px',
  fontSize: '.875rem',
  fontWeight: '500',
  [theme.breakpoints.down('sm')]: {
    lineHeight: '24px',
    fontSize: '16px',
    fontWeight: '700',
    color: theme.palette.secondary.swatch['90'],
  },
}));

export const SlotsHeaderDate = styled('div',
  {shouldForwardProp: (propName) => !['isToday', 'isSelected'].includes(propName)})(
  ({isSelected, isToday, theme}) => ({
    position: 'relative',
    height: '2rem',
    width: '2rem',
    lineHeight: '2rem',
    fontSize: '1rem',
    fontWeight: 'bolder',
    textAlign: 'center',
    borderRadius: '3rem',
    color: theme.palette.text.primary,
    ...(isToday ? {
      '&::after': {
        content: '""',
        backgroundColor: theme.palette.secondary.swatch['50'],
        borderRadius: '12px',
        display: 'block',
        height: '6px',
        width: '6px',
        top: 'calc(100% + 3px)',
        left: 'calc(50% - 3px)',
        position: 'absolute',
      },
    } : null),

    ...(isSelected ? {
      backgroundColor: theme.palette.button.default,
      color: theme.palette.common.white,
    } : null),
  }));
